import $ from 'jquery';
import modaal from 'modaal';
import 'modaal/dist/css/modaal.min.css';

$(() => {
    let $textarea = $('.js_textarea');
    if ($textarea.length) {
        $('.js_linkModal').modaal({
            'hide_close': true,
            'background': '#ddd'
        });

        $('.js_insertCode').on('click', (e) => {
            let $target = $(e.currentTarget);
            const code = $target.attr('data-code');
            $textarea.focus();
            const oldValue = $textarea.val();
            document.execCommand('insertText', false, code);
            const newValue = $textarea.val();
            if (newValue === oldValue) {
                const start = $textarea[0].selectionStart;
                const end = $textarea[0].selectionEnd;
                $textarea.val(
                    [
                        newValue.substr(0, start),
                        code,
                        newValue.substr(end)
                    ].join('')
                );
                $textarea[0].selectionStart = start + code.length;
                $textarea[0].selectionEnd = $textarea[0].selectionStart;
            }
        });

        $('.js_insertCodeLink').on('click', (e) => {
            $('.js_modalInput').val('')
                .attr('data-code', $(e.currentTarget).attr('data-code'));
            $('.js_linkModal').modaal('open');
        });

        $('.js_modalSubmit').on('click', (e) => {
            console.log(e);

            const $input = $('.js_modalInput');
            const url = $input.val();
            if(url === ""){
                return false;
            }
            const code = $input.attr('data-code')
                .replace(/ここにURLを入れる/, url);

            $textarea.focus();
            const oldValue = $textarea.val();
            document.execCommand('insertText', false, code);
            const newValue = $textarea.val();
            if (newValue === oldValue) {
                const start = $textarea[0].selectionStart;
                const end = $textarea[0].selectionEnd;
                $textarea.val(
                    [
                        newValue.substr(0, start),
                        code,
                        newValue.substr(end)
                    ].join('')
                );
                $textarea[0].selectionStart = start + code.length;
                $textarea[0].selectionEnd = $textarea[0].selectionStart;
            }
            $('.js_linkModal').modaal('close');
        });
    }
});
